module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [(_vm.process !== 'next_actions') ? _c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateContestLayout($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.process === 'step_1') ? _c('div', {
    key: "step_1"
  }, [_c('div', {
    staticClass: "col-sm-7 scroll-column"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "form-md-checkboxes margin-bottom-20"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.skip_form),
      expression: "contestLayout.form.skip_form"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-skip-form-step",
      "disabled": _vm.process !== 'step_1'
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.skip_form) ? _vm._i(_vm.contestLayout.form.skip_form, null) > -1 : (_vm.contestLayout.form.skip_form)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contestLayout.form.skip_form,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.skip_form = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.skip_form = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form, "skip_form", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-skip-form-step"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n\t                    \t\t\t\t\t\t\tSkip Form Step\n\t                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
    attrs: {
      "content": 'Enabling this will bypass the form and take the user directly to the digital scratch card.'
    }
  })], 1)])])]), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Language")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "forceUpdate": _vm.transitionComplete
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.contestLayout.form.language) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setFormLanguage('english')
      }
    }
  }, [_vm._v("English")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setFormLanguage('french')
      }
    }
  }, [_vm._v("French")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.form.form_instructions),
      expression: "contestLayout.form.form_instructions",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.form.form_instructions.length
    },
    attrs: {
      "type": "text",
      "id": "edit_design_layout_form_instructions",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.form.form_instructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.form, "form_instructions", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_design_layout_form_instructions"
    }
  }, [_vm._v("Form Instructions")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The instructions that will be presented to the user.")])]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'ig' && !_vm.contestLayout.form.skip_form) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.form.thank_you_text),
      expression: "contestLayout.form.thank_you_text",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.form.thank_you_text.length
    },
    attrs: {
      "type": "text",
      "id": "edit_design_layout_thank_you",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.form.thank_you_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.form, "thank_you_text", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_design_layout_thank_you"
    }
  }, [_vm._v("Thank You Message")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The message that will be presented to the user.")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.contestLayout.form.min_age),
      expression: "contestLayout.form.min_age",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.form.min_age || _vm.contestLayout.form.min_age === 0
    },
    attrs: {
      "type": "number",
      "id": "edit_design_layout_form_min_age",
      "disabled": _vm.contestLayout.form.no_age
    },
    domProps: {
      "value": (_vm.contestLayout.form.min_age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.form, "min_age", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_design_layout_form_min_age"
    }
  }, [_vm._v("Age Limit")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("Set the minimum age required for the user to enter the contest.")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
    staticClass: "form-md-checkboxes margin-bottom-20"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.no_age),
      expression: "contestLayout.form.no_age"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-no-age-limit",
      "disabled": _vm.process !== 'step_1'
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.no_age) ? _vm._i(_vm.contestLayout.form.no_age, null) > -1 : (_vm.contestLayout.form.no_age)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contestLayout.form.no_age,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.no_age = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.no_age = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form, "no_age", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-no-age-limit"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n\t                \t\t\t\t\t\t\tNo age limit\n\t                \t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n\t                \t\t\t\t\t\tForm Information\n\t                \t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('span', {
    staticClass: "help-block"
  }, [_vm._v("Choose the fields to show on the form and which fields are required.")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20 row search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click font-grey-mint"
  }, [_vm._v("Request Field")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click font-grey-mint"
  }, [_vm._v("Require Field")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('h4', [_vm._v("Full Name")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.full_name.request),
      expression: "contestLayout.form.fields.full_name.request"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_full_name_request"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.full_name.request) ? _vm._i(_vm.contestLayout.form.fields.full_name.request, null) > -1 : (_vm.contestLayout.form.fields.full_name.request)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.full_name.request,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.full_name.request = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.full_name.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.full_name, "request", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('request', 'full_name')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_full_name_request"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.full_name.require),
      expression: "contestLayout.form.fields.full_name.require"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_full_name_require"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.full_name.require) ? _vm._i(_vm.contestLayout.form.fields.full_name.require, null) > -1 : (_vm.contestLayout.form.fields.full_name.require)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.full_name.require,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.full_name.require = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.full_name.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.full_name, "require", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('require', 'full_name')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_full_name_require"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', [_vm._v("Email")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.email.request),
      expression: "contestLayout.form.fields.email.request"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_email_request"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.email.request) ? _vm._i(_vm.contestLayout.form.fields.email.request, null) > -1 : (_vm.contestLayout.form.fields.email.request)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.email.request,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.email.request = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.email.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.email, "request", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('request', 'email')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_email_request"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.email.require),
      expression: "contestLayout.form.fields.email.require"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_email_require"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.email.require) ? _vm._i(_vm.contestLayout.form.fields.email.require, null) > -1 : (_vm.contestLayout.form.fields.email.require)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.email.require,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.email.require = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.email.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.email, "require", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('require', 'email')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_email_require"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', [_vm._v("Phone #")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.phone.request),
      expression: "contestLayout.form.fields.phone.request"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_phone_request"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.phone.request) ? _vm._i(_vm.contestLayout.form.fields.phone.request, null) > -1 : (_vm.contestLayout.form.fields.phone.request)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.phone.request,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.phone.request = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.phone.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.phone, "request", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('request', 'phone')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_phone_request"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.phone.require),
      expression: "contestLayout.form.fields.phone.require"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_phone_require"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.phone.require) ? _vm._i(_vm.contestLayout.form.fields.phone.require, null) > -1 : (_vm.contestLayout.form.fields.phone.require)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.phone.require,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.phone.require = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.phone.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.phone, "require", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('require', 'phone')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_phone_require"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', [_vm._v("Date of Birth")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.dob.request),
      expression: "contestLayout.form.fields.dob.request"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_dob_request"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.dob.request) ? _vm._i(_vm.contestLayout.form.fields.dob.request, null) > -1 : (_vm.contestLayout.form.fields.dob.request)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.dob.request,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.dob.request = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.dob.request = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.dob, "request", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('request', 'dob')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_dob_request"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.fields.dob.require),
      expression: "contestLayout.form.fields.dob.require"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "form_fields_dob_require"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.fields.dob.require) ? _vm._i(_vm.contestLayout.form.fields.dob.require, null) > -1 : (_vm.contestLayout.form.fields.dob.require)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.contestLayout.form.fields.dob.require,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.fields.dob.require = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.fields.dob.require = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form.fields.dob, "require", $$c)
        }
      }, function($event) {
        _vm.forceFieldSelection('require', 'dob')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_fields_dob_require"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form) ? _c('div', {
    staticClass: "form-md-checkboxes"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.form.thank_you_email),
      expression: "contestLayout.form.thank_you_email"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-email-response",
      "disabled": _vm.process !== 'step_1'
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.form.thank_you_email) ? _vm._i(_vm.contestLayout.form.thank_you_email, null) > -1 : (_vm.contestLayout.form.thank_you_email)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contestLayout.form.thank_you_email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.form.thank_you_email = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.form.thank_you_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.form, "thank_you_email", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-email-response"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n                    \t\t\t\t\t\t\tEnable response email\n                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
    attrs: {
      "content": 'This will send the user an email response after entering the contest.'
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form && _vm.contestLayout.form.thank_you_email) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.form.email_fields.sender),
      expression: "contestLayout.form.email_fields.sender",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.form.email_fields.sender.length
    },
    attrs: {
      "type": "text",
      "id": "edit_design_layout_email_sender",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.form.email_fields.sender)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.form.email_fields, "sender", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_design_layout_email_sender"
    }
  }, [_vm._v("Sender Name")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The email will send from do-not-reply@unoapp.com.")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form && _vm.contestLayout.form.thank_you_email) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.form.email_fields.subject),
      expression: "contestLayout.form.email_fields.subject",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.form.email_fields.subject.length
    },
    attrs: {
      "type": "text",
      "id": "edit_design_layout_email_subject",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.form.email_fields.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.form.email_fields, "subject", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_design_layout_email_subject"
    }
  }, [_vm._v("Subject")])]) : _vm._e(), _vm._v(" "), (!_vm.contestLayout.form.skip_form && _vm.contestLayout.form.thank_you_email) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.form.email_fields.body),
      expression: "contestLayout.form.email_fields.body",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.form.email_fields.body.length
    },
    attrs: {
      "type": "text",
      "id": "edit_design_layout_email_body",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.form.email_fields.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.form.email_fields, "body", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_design_layout_email_body"
    }
  }, [_vm._v("Body")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20 margin-bottom-100"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    key: "edit-contest-design-continue-one",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_2', 'step_1')
      }
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('contest-preview', {
    attrs: {
      "design": _vm.contestLayout.design,
      "form": _vm.contestLayout.form,
      "agreement": _vm.contestLayout.agreement
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
    key: "step_2"
  }, [_c('div', {
    staticClass: "col-sm-7 scroll-column"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.text_color),
      expression: "contestLayout.design.text_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.text_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_text_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.text_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "text_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_text_color"
    }
  }, [_vm._v("Text Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.text_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "text_color", $$v)
      },
      expression: "contestLayout.design.text_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.input_text_color),
      expression: "contestLayout.design.input_text_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.input_text_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_input_text_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.input_text_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "input_text_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_input_text_color"
    }
  }, [_vm._v("Input Text Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.input_text_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "input_text_color", $$v)
      },
      expression: "contestLayout.design.input_text_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.background_color),
      expression: "contestLayout.design.background_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.background_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_background_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.background_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "background_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_background_color"
    }
  }, [_vm._v("Background Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.background_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "background_color", $$v)
      },
      expression: "contestLayout.design.background_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.design.background_image),
      expression: "contestLayout.design.background_image",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.background_image.length
    },
    attrs: {
      "type": "text",
      "id": "design_background_image"
    },
    domProps: {
      "value": (_vm.contestLayout.design.background_image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "background_image", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_background_image"
    }
  }, [_vm._v("Background Image")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.design.header_image),
      expression: "contestLayout.design.header_image",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.header_image.length
    },
    attrs: {
      "type": "text",
      "id": "design_header_image"
    },
    domProps: {
      "value": (_vm.contestLayout.design.header_image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "header_image", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_header_image"
    }
  }, [_vm._v("Header Image")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.design.footer_image),
      expression: "contestLayout.design.footer_image",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.footer_image.length
    },
    attrs: {
      "type": "text",
      "id": "design_footer_image"
    },
    domProps: {
      "value": (_vm.contestLayout.design.footer_image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "footer_image", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_footer_image"
    }
  }, [_vm._v("Footer Image")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.footer_background_color),
      expression: "contestLayout.design.footer_background_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.footer_background_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_footer_background_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.footer_background_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "footer_background_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_footer_background_color"
    }
  }, [_vm._v("Footer Background Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.footer_background_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "footer_background_color", $$v)
      },
      expression: "contestLayout.design.footer_background_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.footer_border_color),
      expression: "contestLayout.design.footer_border_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.footer_border_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_footer_border_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.footer_border_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "footer_border_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_footer_border_color"
    }
  }, [_vm._v("Footer Border Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.footer_border_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "footer_border_color", $$v)
      },
      expression: "contestLayout.design.footer_border_color"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.input_background_color),
      expression: "contestLayout.design.input_background_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.input_background_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_input_background_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.input_background_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "input_background_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_input_background_color"
    }
  }, [_vm._v("Input Background Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.input_background_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "input_background_color", $$v)
      },
      expression: "contestLayout.design.input_background_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.input_placeholder_color),
      expression: "contestLayout.design.input_placeholder_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.input_placeholder_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_input_placeholder_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.input_placeholder_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "input_placeholder_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_input_placeholder_color"
    }
  }, [_vm._v("Input Placeholder Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.input_placeholder_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "input_placeholder_color", $$v)
      },
      expression: "contestLayout.design.input_placeholder_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.button_text_color),
      expression: "contestLayout.design.button_text_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.button_text_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_button_text_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.button_text_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "button_text_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_button_text_color"
    }
  }, [_vm._v("Button Text Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.button_text_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "button_text_color", $$v)
      },
      expression: "contestLayout.design.button_text_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.button_background_color),
      expression: "contestLayout.design.button_background_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.button_background_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_button_background_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.button_background_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "button_background_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_button_background_color"
    }
  }, [_vm._v("Button Background Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.button_background_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "button_background_color", $$v)
      },
      expression: "contestLayout.design.button_background_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('div', {
    staticClass: "input-icon right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.design.button_background_hover_color),
      expression: "contestLayout.design.button_background_hover_color"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.design.button_background_hover_color.length
    },
    attrs: {
      "type": "text",
      "id": "design_button_background_hover_color"
    },
    domProps: {
      "value": (_vm.contestLayout.design.button_background_hover_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.design, "button_background_hover_color", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "design_button_background_hover_color"
    }
  }, [_vm._v("Button Hover Color")]), _vm._v(" "), _c('i', {
    staticClass: "wide clickable"
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: (_vm.contestLayout.design.button_background_hover_color),
      callback: function($$v) {
        _vm.$set(_vm.contestLayout.design, "button_background_hover_color", $$v)
      },
      expression: "contestLayout.design.button_background_hover_color"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Font Family")]), _vm._v(" "), _c('font-picker', {
    attrs: {
      "passedFont": _vm.contestLayout.design.font_family
    },
    on: {
      "updateFont": _vm.setFontFamily
    }
  })], 1), _vm._v(" "), (_vm.contestLayout.design.font_family.family) ? _c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Font Weight")]), _vm._v(" "), _c('dropdown', {
    staticClass: "full-width"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default full-width",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.contestLayout.design.font_weight || 'Select a Font Weight') + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-angle-down pull-right"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu full-width",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_vm._l((_vm.fontWeights), function(weight) {
    return [(_vm.contestLayout.design.font_family.variants.indexOf(weight.name) !== -1) ? _c('li', [_c('a', {
      style: ({
        fontWeight: weight.weight
      }),
      on: {
        "click": function($event) {
          _vm.setFontWeight(weight)
        }
      }
    }, [_vm._v(_vm._s(weight.weight))])]) : _vm._e()]
  })], 2)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20 margin-bottom-100"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "edit-contest-design-continue-two",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_3', 'step_2')
      }
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('contest-preview', {
    attrs: {
      "design": _vm.contestLayout.design,
      "form": _vm.contestLayout.form,
      "agreement": _vm.contestLayout.agreement
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
    key: "step_3"
  }, [_c('div', {
    staticClass: "col-sm-7 scroll-column"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.agreement.urls[0].url),
      expression: "contestLayout.agreement.urls[0].url",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.agreement.urls[0].url.length
    },
    attrs: {
      "type": "text",
      "id": "edit_agreement_url_1",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.agreement.urls[0].url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.agreement.urls[0], "url", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_agreement_url_1"
    }
  }, [_vm._v("Agreement URL")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.agreement.urls[0].name),
      expression: "contestLayout.agreement.urls[0].name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.agreement.urls[0].name.length
    },
    attrs: {
      "type": "text",
      "id": "edit_agreement_name_1",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.agreement.urls[0].name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.agreement.urls[0], "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_agreement_name_1"
    }
  }, [_vm._v("Agreement Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.agreement.urls[1].url),
      expression: "contestLayout.agreement.urls[1].url",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.agreement.urls[1].url.length
    },
    attrs: {
      "type": "text",
      "id": "edit_agreement_url_2",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.agreement.urls[1].url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.agreement.urls[1], "url", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_agreement_url_2"
    }
  }, [_vm._v("Agreement URL")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.agreement.urls[1].name),
      expression: "contestLayout.agreement.urls[1].name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.agreement.urls[1].name.length
    },
    attrs: {
      "type": "text",
      "id": "edit_agreement_name_2",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.agreement.urls[1].name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.agreement.urls[1], "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_agreement_name_2"
    }
  }, [_vm._v("Agreement Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.agreement.terms_error),
      expression: "contestLayout.agreement.terms_error",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.agreement.terms_error.length
    },
    attrs: {
      "type": "text",
      "id": "edit_agreement_terms_error",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.agreement.terms_error)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.agreement, "terms_error", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_agreement_terms_error"
    }
  }, [_vm._v("Terms and Conditions Error")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The message that will be displayed to the user if they fail to accept the terms and conditions.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-md-checkboxes margin-top-40"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contestLayout.agreement.require_access_code),
      expression: "contestLayout.agreement.require_access_code"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-require-access-code"
    },
    domProps: {
      "checked": Array.isArray(_vm.contestLayout.agreement.require_access_code) ? _vm._i(_vm.contestLayout.agreement.require_access_code, null) > -1 : (_vm.contestLayout.agreement.require_access_code)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contestLayout.agreement.require_access_code,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contestLayout.agreement.require_access_code = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contestLayout.agreement.require_access_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.contestLayout.agreement, "require_access_code", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-require-access-code"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n                    \t\t\t\t\t\t\tRequire Access Code\n                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
    attrs: {
      "content": 'Access Code is used to verify that a prize has been redeemed.'
    }
  })], 1)])]), _vm._v(" "), (_vm.contestLayout.agreement.require_access_code) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.contestLayout.agreement.access_code),
      expression: "contestLayout.agreement.access_code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.contestLayout.agreement.access_code.length
    },
    attrs: {
      "type": "text",
      "id": "edit_agreement_access_code",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.contestLayout.agreement.access_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contestLayout.agreement, "access_code", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "edit_agreement_access_code"
    }
  }, [_vm._v("Access Code")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The access code that is required to claim the prize.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20 margin-bottom-100"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('contest-preview', {
    attrs: {
      "design": _vm.contestLayout.design,
      "form": _vm.contestLayout.form,
      "agreement": _vm.contestLayout.agreement
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
    attrs: {
      "steps": _vm.steps,
      "process": _vm.process
    }
  })], 1)])]) : _c('next-actions', {
    attrs: {
      "actionsList": _vm.editContestLayoutNextActions
    },
    on: {
      "runFunction": _vm.runFunction
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\tEdit Contest Layout\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2dd180d1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UNOgames/EditContestLayout.vue
// module id = 418
// module chunks = 1